import { useRef, useState } from 'react';

import './ExpertBanner.scss';
import Portal from '../Portal/Portal.jsx';
import { src, srcSet } from '../../helpers/image';
import Location from '../../shared/assets/icons/redesign/location.svg';

export default function ExpertBanner({ expert }) {
  const ref = useRef();
  const [showPopup, setShowPopup] = useState(true);

  const expertPageLink = expert.website || expert.link;

  return (
    <>
      {showPopup && (
        <Portal>
          <div className="expertBanner">
            <div className="expertBanner-img-wrap" ref={ref}>
              <img
                alt="expert-image"
                className="expertBanner-img"
                srcSet={srcSet(expert.imageUrl, { width: 110, height: 110 })}
              />
            </div>

            <div>
              <h5 className="expertBanner-title">{expert.displayName}</h5>

              <h6 className="expertBanner-subtitle">{expert.subTitle}</h6>

              <span className="expertBanner-text-small">
                Deskundige in de buurt
              </span>
            </div>

            <div className="expertBanner-actions">
              <button
                onClick={() => setShowPopup(false)}
                className="expertBanner-close-btn cursor-pointer"
              >
                &times;
              </button>

              <a
                className="expertBanner-more-info-btn"
                href={expertPageLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                Lees meer
              </a>
            </div>
          </div>
        </Portal>
      )}

      <section
        className="expertBox"
        onClick={() => (location.href = expertPageLink)}
      >
        <h3 className="expertBox-header">
          <Location className="expertBox-logo" /> Deskundige in jouw buurt
        </h3>

        <div>
          <img
            alt="expertBox-image"
            className="expertBox-image"
            src={src(expert.imageUrl, 400, 225)}
          />

          <div className="expertBox-info">
            <p className="expertBox-title">{expert.subTitle}</p>

            <div className="expertBox-contact-info">
              <p className="expertBox-name">{expert.displayName}</p>

              <button className="expertBox-contact-button">Lees meer</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
